export default __webpack_public_path__ + "static/media/home-bg-one.78326d66.svg";